// eslint-disable import-x/no-unused-modules -- this function will only get used if we have any feature flags
export function featureFlag(flag: string): boolean {
  return Boolean(window?.config?.featureFlags?.[flag]);
}
